module.exports = __webpack_public_path__ + "static/img/2023_9_8_5.5d585403.5d58540.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_5.5d585403.png
// module id = opch
// module chunks = 0